import noodleApiClient, { ApiDefinition } from '@noodleApi';
import buildPath from '@tsClient/utilities/buildPath';

type THIS_API = ApiDefinition['/messages/{id}']['PUT'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const updateMessageById = async ({ id, ...body }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/messages/{id}', { id });
  const response = await noodleApiClient.put(path, body);
  return response.data;
};

export default updateMessageById;
